import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

export const TabType = {
    WORK_STATUS: {
        key: "WORK_STATUS",
        name: "工作状态设置",
    },
    UNIT_DUTY: {
        key: "UNIT_DUTY",
        name: "科室角色/岗位设置",
    },
    OTHERS: {
        key: "OTHERS",
        name: "其他设置",
    },
};

const initState = {
    selectedTab: TabType.WORK_STATUS.key,
    loading: false,
};

const [
    viewModel,
    update, reset,
] = BaseUtil.getViewModel(initState, type);

export {
    update, reset,
};

export default viewModel;
